import React from 'react';
import { Link } from 'react-router-dom';
import { buttonClasses } from '../utils/buttonStyles';
export function NotFound() {
  return <div className="mx-auto max-w-site px-5 py-32 md:px-8" data-id="element-1194" data-mp="w4t0kp2c0ng5">
      <h1 className="font-display text-6xl font-semibold uppercase" data-id="element-1195" data-mp="105ldptebrchp">Page not found</h1>
      <p className="mt-4 text-titanium" data-id="element-1196" data-mp="154pim7u7uo28">The page you're looking for doesn't exist.</p>
      <Link to="/" className={`${buttonClasses('primary')} mt-8`} data-id="element-1197" data-mp="1a4268uswvz5v">Return home</Link>
    </div>;
}